export default __webpack_public_path__ + "static/media/2.c1a8e83c.svg";